// extracted by mini-css-extract-plugin
export default {"item":"styles__item--QUrlA","code":"styles__code--nRJc2","description":"styles__description--jEg-B"};